import React from "react";
import styles from "./SeriesStatsPopover.module.css";

/**
 * SeriesStatsPopover — body of the (i)-icon tooltip in the chart legend.
 *
 * Renders the per-series Average & Distributions percentages (3 colored
 * values: green / amber / red) and Min/Max/Median values. Pixel-perfect
 * reference: Figma "RPM TOCA AI Patient Dashboard" — series stats
 * tooltip (image 29).
 *
 * Props:
 *   - title:        string — series name shown as the heading (e.g. "Systolic")
 *   - percentages:  array of { value, color, label? } — 3 entries (Normal /
 *                   Elevated / Critical) for BP/HR; renders nothing if absent.
 *   - minMaxMedian: { min, max, median } — numeric values; "—" placeholder
 *                   if undefined.
 */
const SeriesStatsPopover = ({ title, percentages, minMaxMedian }) => {
  return (
    <div className={styles.card}>
      <h4 className={styles.heading}>{title}</h4>

      {Array.isArray(percentages) && percentages.length > 0 && (
        <>
          <p className={styles.sectionLabel}>Average &amp; Distributions</p>
          <div className={styles.percentagesRow}>
            {percentages.map((pct, idx) => (
              <span
                key={idx}
                className={styles.percentage}
                style={{ color: pct.color }}
                aria-label={pct.label}
              >
                {pct.value}%
              </span>
            ))}
          </div>
          <div className={styles.divider} />
        </>
      )}

      <p className={styles.sectionLabel}>Min/Max Values</p>
      <div className={styles.minMaxRow}>
        <span className={styles.minMaxItem}>Min:{fmt(minMaxMedian?.min)}</span>
        <span className={styles.minMaxItem}>Max:{fmt(minMaxMedian?.max)}</span>
        <span className={styles.minMaxItem}>
          Median: {fmt(minMaxMedian?.median)}
        </span>
      </div>
    </div>
  );
};

const fmt = (v) => (v === undefined || v === null || Number.isNaN(v) ? "—" : v);

export default SeriesStatsPopover;
